<app-modals [title]="title" [openModal]="openModal" [closeModal]="closeModal" [whenModalClose]="whenModalClose" [submitKey]="submitKey" [invalidFormGroup]="$safeNavigationMigration(entry?.invalid)" [isShaking]="$safeNavigationMigration(errors?.length) > 0">
  <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">
    @if (errors?.length > 0) {
      <div class="row">
        <div class="col-12">
          <app-form-errors [errors]="errors"></app-form-errors>
        </div>
      </div>
    }

    <div class="row mt-2">
      <app-forms-form-group [value]="entry.get('label')" fieldName="label" [fieldLabel]="'MODALS.JOBS.NAME' | translate"><input class="form-control" id="label" type="text" autocomplete="label" placeholder="label" formControlName="label" appAutoFocus="appAutoFocus" /></app-forms-form-group>
    </div>

    <div class="row">
      <div class="col-12">
        <p class="text-muted small mb-2">{{ 'MODALS.JOBS.QUESTION_SET_DESCRIPTION' | translate }}</p>

        <app-forms-form-group [value]="entry.get('question_set_id')" [formGroup]="entry" fieldName="question_set_id" [fieldLabel]="'MODALS.JOBS.QUESTION_SET' | translate" [isRequired]="false"><select class="form-control form-select" id="question_set_id" formControlName="question_set_id" placeholder="question_set_id">
          <option [ngValue]="''">{{ 'COMMON.NONE' | translate }}</option>
          @for (qs of questionSets; track qs) {
            <option [ngValue]="qs.value">{{ qs.label }}</option>
          }
        </select></app-forms-form-group>
      </div>
    </div>
  </form>
</app-modals>
